
import { defineComponent } from 'vue'
import NumberCard from '../components/NumberCard.vue'
import { getAllKoreanNumbers } from '@/services/KoreanDataService'

export default defineComponent({
  name: 'KoreanNumbers',
  components: {
    NumberCard,
  },
  data() {
    return {
      koreanNumbers: getAllKoreanNumbers(),
    }
  },
})
